import { useParams } from 'react-router-dom';
import { useCallback, useEffect, useState } from 'react';
import {
  BaseEitherError,
  G25,
  HeroOnboardingWelcomeMessage,
  HeroSplitLayout,
  useHeroSnackbar,
  useTranslations,
  decodeExtensionCommunicationPayload,
  useBooleanState,
} from '@uniqkey-frontend/shared-app';
import OnboardingModule from '../../services/onboarding';
import CommunicationMessage from './components/CommunicationMessage';
import ErrorMessage from './components/ErrorMessage';

const MAIN_CONTAINER_PROPS = { bgcolor: G25 };

const AutoActivationPage = () => {
  const params = useParams();
  const { t } = useTranslations();
  const { showError } = useHeroSnackbar();

  const { hash } = params;

  const [decoded] = useState(() => decodeExtensionCommunicationPayload(hash));
  const {
    value: isError,
    setValue: setIsError,
  } = useBooleanState(false);

  const handleError = useCallback(() => {
    setIsError(true);
    showError({ text: t('common.somethingWentWrong') });
  }, [setIsError, showError, t]);

  useEffect(() => {
    if (isError) {
      return;
    }
    if (!decoded) {
      handleError();
      return;
    }
    if (OnboardingModule.isInProgress()) { // is used for the development mode
      return;
    }
    const run = async () => {
      const result = await OnboardingModule.start({ decoded, hash: hash! });
      if (result instanceof BaseEitherError) {
        handleError();
      }
    };
    run();
  }, [decoded, handleError, hash, isError]);

  const { email, name } = decoded ?? {};

  return (
    <HeroSplitLayout
      LeftContent={(
        <HeroOnboardingWelcomeMessage
          title={t('onboarding.welcome.title', { name: name ?? email })}
          description={t('onboarding.welcome.description')}
        />
      )}
      RightContent={isError ? <ErrorMessage /> : <CommunicationMessage />}
      mainContainerProps={MAIN_CONTAINER_PROPS}
    />
  );
};

export default AutoActivationPage;
